module.exports = __webpack_public_path__ + "img/m1-screenshot-08.2d666da7.png";